// @flow
import React, { useState } from 'react';
import { themr } from 'react-css-themr';
import EnhancedInput from 'common/components/core/input';
import defaultTheme from './TransactionTimeInput.scss';
import NumberUtils from 'common/utils/NumberUtils';
import DataUtils from 'common/utils/DataUtils';

type Props = {
    theme: {},
    t: (string, ?Object) => string,
    handleRightIconClick: Function,
    onChange: Function,
    data: ?number,
    disabled?: boolean
};

const TransactionTimeInput = (props: Props) => {
    const {
        theme,
        t,
        data,
        handleRightIconClick,
        testId,
        onChange,
        disabled
    } = props;
    const [duration, setDuration] = useState(
        NumberUtils.roundOff((data || 0) / 60)
    );
    const onChangeHandler = function (value) {
        if (!NumberUtils.isNumeric(value) && !DataUtils.isEmpty(value)) {
            return;
        }
        setDuration(value);
        return onChange(value);
    };
    return (
        <div className={theme.transactionTimeInputWrapper}>
            <div className={theme.transactionTimeLabel}>
                {t('masterRiderPersonaProperties.transactionTimePerTask')}
            </div>
            <EnhancedInput
                theme={theme}
                className={theme.input}
                min={'0'}
                rightIcon={t('translations:minutes_short')}
                handleRightIconClick={handleRightIconClick}
                value={duration}
                onChange={onChangeHandler}
                disabled={disabled}
                testId={testId}
            />
        </div>
    );
};

export default themr(
    'TransactionTimeInput',
    defaultTheme
)(TransactionTimeInput);
